import * as React from "react";
import { ButtonListItem } from "./ButtonListItem";
import { LocationAddress, Maybe } from "../../generated/nest-graphql";
import { formatLocationAddress } from "../../lib/serviceLocation";

export const ServiceLocationListItem: React.FC<{
  address: string;
  serviceLocationAddress?: Maybe<LocationAddress>;
  notes: string | undefined | null;
}> = ({ address, serviceLocationAddress, notes }) => {
  // Prefer the structured address: a partial serviceLocation (e.g. a street with no city) lets
  // Google Maps guess the city and send the technician to the wrong place (NUB-466).
  const destination = formatLocationAddress(serviceLocationAddress) ?? address;
  const mapUrl = `//maps.google.com/maps?daddr=${encodeURIComponent(destination)}`;
  return <ButtonListItem primary={destination} secondary={notes} href={mapUrl} buttonText={"Map"} />;
};
